const EvaluatorAction = {
  FORM_SUBMIT: 'FORM_SUBMIT',
  EVAL_REQUEST: 'EVAL_REQUEST',
  EVAL_SUCCESS: 'EVAL_SUCCESS',
  EVAL_ERROR: 'EVAL_ERROR',
};

export default EvaluatorAction;
